import { NavLink } from "react-router";

const AccessTabs = () => (
    <div className="access-tabs">
        <NavLink to="/access" end>Users</NavLink>
        <NavLink to="/access/roles">Roles</NavLink>
    </div>
);

export default AccessTabs;
